<template>
  <div class="active-chutes-dialog">
    <h4 class="dialog-title error">
      <i class="fal fa-exclamation-circle"></i>
      ບໍ່ສາມາດດໍາເນີນການໄດ້
    </h4>

    <div class="error-content">
      <div class="error-icon">
        <i class="fal fa-boxes"></i>
      </div>
      <div class="error-text">
        <p>ມີຊ່ອງທີ່ຍັງມີພັດສະດຸຢູ່. ກະລຸນາລ້າງຊ່ອງທັງໝົດກ່ອນດໍາເນີນການ.</p>
      </div>
    </div>

    <div class="active-chutes-list">
      <h5 class="list-title">
        <i class="fal fa-layer-group"></i>
        ຊ່ອງທີ່ມີພັດສະດຸ ({{ chutes.length }})
      </h5>
      <div class="chutes-grid">
        <div
          v-for="chute in chutes"
          :key="chute.chute_number"
          class="chute-item"
        >
          <div class="chute-info">
            <span class="chute-number">ຊ່ອງ {{ String(chute.chute_number).padStart(2, '0') }}</span>
            <span class="chute-count">{{ chute.current_package_count }} ພັດສະດຸ</span>
            <span :class="['chute-status', chute.status]">{{ getStatusLabel(chute.status) }}</span>
          </div>
          <vs-button
            v-if="chute.status === 'error' || (chute.is_error_chute && chute.status !== 'empty')"
            danger
            size="small"
            flat
            @click="$emit('clear-chute', chute.chute_number)"
            :loading="clearingChuteNumber === chute.chute_number"
          >
            <i class="fal fa-broom"></i>
          </vs-button>
          <vs-button
            v-else
            success
            size="small"
            flat
            @click="$emit('print-chute', chute.chute_number)"
            :loading="printingChuteNumber === chute.chute_number"
          >
            <i class="fal fa-print"></i>
          </vs-button>
        </div>
      </div>
    </div>

    <div class="dialog-actions">
      <vs-button flat @click="$emit('close')">ປິດ</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActiveChutesErrorDialog',

  props: {
    chutes: {
      type: Array,
      default: () => []
    },
    message: {
      type: String,
      default: ''
    },
    printingChuteNumber: {
      type: Number,
      default: null
    },
    clearingChuteNumber: {
      type: Number,
      default: null
    }
  },

  methods: {
    getStatusLabel(status) {
      const labels = {
        'active': 'ກຳລັງໃຊ້ງານ',
        'full': 'ເຕັມ',
        'packing': 'ກຳລັງແພັກ',
        'error': 'ຂໍ້ຜິດພາດ'
      };
      return labels[status] || status;
    }
  }
};
</script>

<style lang="scss" scoped>
.active-chutes-dialog {
  padding: 10px;
}

.dialog-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 20px;

  &.error {
    color: #c62828;
  }

  i {
    margin-right: 8px;
  }
}

.error-content {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 15px;
  background: #ffebee;
  border-radius: 10px;
  border-left: 4px solid #c62828;
  margin-bottom: 20px;
}

.error-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffcdd2;
  border-radius: 50%;

  i {
    font-size: 24px;
    color: #c62828;
  }
}

.error-text {
  flex: 1;

  p {
    margin: 0;
    color: #333;
    font-size: 14px;
  }
}

.active-chutes-list {
  .list-title {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 12px;

    i {
      margin-right: 6px;
      color: #ff9800;
    }
  }
}

.chutes-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 250px;
  overflow-y: auto;
}

.chute-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: #f5f5f5;
  border-radius: 8px;
  border: 1px solid #e0e0e0;

  .chute-info {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .chute-number {
    font-weight: 700;
    color: #333;
    min-width: 60px;
  }

  .chute-count {
    font-size: 13px;
    color: #666;
    padding: 2px 8px;
    background: #fff3e0;
    border-radius: 10px;
    color: #ef6c00;
  }

  .chute-status {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 10px;
    font-weight: 500;

    &.active {
      background: #e8f5e9;
      color: #2e7d32;
    }

    &.full {
      background: #fff3e0;
      color: #ef6c00;
    }

    &.packing {
      background: #e3f2fd;
      color: #1565c0;
    }

    &.error {
      background: #ffebee;
      color: #c62828;
    }
  }
}

.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}
</style>
